import Cookies from 'js-cookie';

const priceWithoutVATCookieName = 'priceWithoutVAT';

// Import duties replace VAT in the UA region: the toggle is not rendered there and
// prices are always shown without VAT, so the cookie must never be read or written.
const isImportTaxesRegion = () => window.IS_IMPORT_TAXES_REGION === true;

const sixMonthsInMs = 6 * 30 * 24 * 60 * 60 * 1000;
const sixMonthsInDate = new Date(Date.now() + sixMonthsInMs);

const getPriceVatText = ({
  isPriceWithVat,
  isSellerVatEnabled,
}) => {
  const { withVat, withoutVat, notExcludedVat } = window.TRANSLATIONS.search.noVatToggle;

  if (isSellerVatEnabled) {
    if (isPriceWithVat) {
      return withVat;
    }
    return withoutVat;
  }
  return notExcludedVat;
};

const getPriceVatTooltipText = ({
  isPriceWithVat,
  isSellerVatEnabled,
}) => {
  const {
    sellerVatPayerToggleEnabled,
    sellerVatPayerToggleDisabled,
    sellerNotVatPayerToggleEnabled,
    sellerNotVatPayerToggleDisabled,
  } = window.TRANSLATIONS.search.noVatToggle;

  if (isSellerVatEnabled) {
    if (isPriceWithVat) return sellerVatPayerToggleEnabled;
    return sellerVatPayerToggleDisabled;
  }
  if (isPriceWithVat) return sellerNotVatPayerToggleEnabled;
  return sellerNotVatPayerToggleDisabled;
};

const initPriceWithVatState = () => {
  if (isImportTaxesRegion()) {
    return;
  }

  const priceWithoutVat = Cookies.get(priceWithoutVATCookieName);
  const checkbox = $('.priceWithVatInput');

  const isWithoutVat = priceWithoutVat === 'true';
  checkbox.prop('checked', !isWithoutVat);
  if (!isWithoutVat) {
    checkbox.prop('checked', true);
    Cookies.set(priceWithoutVATCookieName, 'false', {
      expires: sixMonthsInDate,
      path: '/',
    });
  }
};

const getPriceWithVatState = () => !isImportTaxesRegion()
  && Cookies.get(priceWithoutVATCookieName) === 'false';

const setPriceWithoutVatCookies = async () => {
  const checkbox = $('.priceWithVatInput');

  checkbox.prop('checked', !checkbox.prop('checked'));

  const isChecked = checkbox.prop('checked');

  const priceWithoutVat = !isChecked;

  Cookies.set(priceWithoutVATCookieName, priceWithoutVat.toString(), {
    expires: sixMonthsInDate,
  });

  return Promise.resolve(isChecked);
};

export {
  isImportTaxesRegion,
  initPriceWithVatState,
  setPriceWithoutVatCookies,
  getPriceWithVatState,
  getPriceVatText,
  getPriceVatTooltipText,
};
